import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['statusChange'],
});

export const statusChangeApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findStatusChangeAllSelection: builder.query({
      query: () => `status_change/selection_data/`,
      providesTags: ['statusChange'],
    }),
    findStatusChangeAllJobDescriptionSelection: builder.query({
      query: () => `status_change/job_description/selection_data/`,
      providesTags: ['statusChange'],
    }),
    findStatusChangeSearch: builder.query({
      query: (payload) => {
        let url = `status_change/job_description/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
    }),
    findStatusChangeByDispatchBoard: builder.query({
      query: (id) => `dispatch_boards/${id}/`,
      providesTags: ['statusChange'],
      keepUnusedDataFor: 0,
    }),
    findStatusChangeVinDescriptionByCalling: builder.query({
      query: (id) => `status_change/vin_description/?calling_id=${id}`,
      providesTags: ['statusChange'],
    }),
    findStatusChangeVinDescriptionSelectionData: builder.query({
      query: (id) => `status_change/vin_description/selection_data/`,
      providesTags: ['statusChange'],
    }),
    findStatusChangEffectDN: builder.query({
      query: (data) =>
        `status_change/vin_description/check_effect_dn/?calling_no=${data.calling_no}&vin_no=${data.vin_no}&location_destination_id=${data.location_destination}&vehicle_type_id=${data.vehicle_type}`,
      providesTags: ['statusChange'],
    }),
    findStatusChangVehicleTypeAccident: builder.query({
      query: (data) =>
        `status_change/vin_description/check_accident/?calling_no=${data.calling_no}&vin_no=${data.vin_no}&vehicle_type_id=${data.vehicle_type}`,
      providesTags: ['statusChange'],
    }),
    statusChangeByCheckButton: builder.query({
      query: (payload) => ({
        url: `status_change/check_button/`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['statusChange'],
    }),
    updateStatusChange: builder.mutation({
      query: (payload) => ({
        url: `status_change/job_description/`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['statusChange'],
    }),
    statusChangeGenarateJobCode: builder.mutation({
      query: (payload) => ({
        url: `status_change/job_code/`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['statusChange'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindStatusChangeAllSelectionQuery,
  useFindAllDiagramOwnerQuery,
  useFindAllLocationFromToQuery,
  useFindStatusChangeByIdQuery,
  useFindStatusChangeByDispatchBoardQuery,
  useFindStatusChangeVinDescriptionByCallingQuery,
  useFindStatusChangeAllJobDescriptionSelectionQuery,
  useFindStatusChangeVinDescriptionSelectionDataQuery,
  useFindStatusChangeByTypesQuery,
  useUpdateStatusChangeMutation,
  useStatusChangeGenarateJobCodeMutation,
  useFindCurrentTimeStatusChangeQuery,
} = statusChangeApi;
